import { render, staticRenderFns } from "./storeInventoryGoods.vue?vue&type=template&id=1ec2d1e0&scoped=true&"
import script from "./storeInventoryGoods.vue?vue&type=script&lang=js&"
export * from "./storeInventoryGoods.vue?vue&type=script&lang=js&"
import style0 from "./storeInventoryGoods.vue?vue&type=style&index=0&id=1ec2d1e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec2d1e0",
  null
  
)

component.options.__file = "storeInventoryGoods.vue"
export default component.exports